import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import PageHero from "@/components/PageHero";
import { ChevronDown } from "lucide-react";

export default function FAQPage() {
  const { settings } = useSettings();
  const [faqs, setFaqs] = useState([]);
  const [openId, setOpenId] = useState(null);
  useEffect(() => { api.get("/faqs?status=published").then((r) => setFaqs(r.data)); }, []);

  return (
    <div className="bg-[color:var(--marupiara-ivory)]">
      <PageHero image={settings.faq_hero_image} overline="Perguntas Frequentes" title="Dúvidas mais comuns." align="center" />
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6 space-y-3">
          {faqs.map((f) => (
            <div key={f.id} data-testid={`faq-${f.id}`} className="border border-[color:var(--marupiara-gold)]/25 bg-white">
              <button onClick={() => setOpenId(openId === f.id ? null : f.id)} className="w-full flex justify-between items-center gap-4 px-6 py-5 text-left">
                <span className="font-serif text-xl text-[color:var(--marupiara-obsidian)]">{f.question}</span>
                <ChevronDown className={`text-[color:var(--marupiara-gold-dark)] transition-transform ${openId === f.id ? "rotate-180" : ""}`} size={20} />
              </button>
              {openId === f.id && <div className="px-6 pb-6 text-neutral-700 leading-relaxed">{f.answer}</div>}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
